<script setup lang="ts">
  const { disabled, isActive } = defineProps<{
    /** Управляет состоянием активности */
    isActive?: boolean;
    /** Управляет состоянием отключения */
    disabled?: boolean;
  }>();

  const emit = defineEmits<{
    /** Событие для клика
     * @deprecated
     */
    (e: "onclick", event: MouseEvent): void;
    (e: "click", event: MouseEvent): void;
  }>();

  defineSlots<{
    /** Слот для иконки */
    default: unknown;
  }>();

  const handleClick = (event: MouseEvent) => {
    emit("onclick", event);
    emit("click", event);
  };
</script>

<template>
  <button class="icon-button" :class="{ 'icon-button--active': isActive }" :disabled="disabled" @click="handleClick">
    <slot />
  </button>
</template>

<style scoped>
  .icon-button {
    display: flex;
    padding: 6px;
    background-color: transparent;
    border-radius: 8px;
  }

  .icon-button :slotted(svg) {
    stroke: var(--sf-base-icon-secondary);
  }

  .icon-button:hover {
    cursor: pointer;
    background-color: var(--sf-base-background-secondary);
  }

  .icon-button--active,
  .icon-button:active {
    background-color: var(--sf-base-background-secondary);
  }

  .icon-button--active :slotted(svg),
  .icon-button:active :slotted(svg) {
    stroke: var(--sf-base-icon-primary);
  }

  .icon-button:disabled {
    pointer-events: none;
  }
</style>
